import { PackageSubLOBProps } from "components/flexComponents/WizardPackagePWA/typings";
import * as React from "react";
import { observer } from "mobx-react";
import { locKeys } from "components/flexComponents/WizardPackagePWA/l10n";
import { Location } from "src/components/shared/Location/Location";
import { Dates } from "src/components/shared/Dates/Dates";
import { PackagePartialStay } from "components/flexComponents/WizardPackagePWA/components/PackagePartialStay";
import { StaySomewhereElseToggle } from "components/flexComponents/WizardPackagePWA/components/StaySomewhereElseToggle";
import { StaySomewhereElse } from "components/flexComponents/WizardPackagePWA/components/StaySomewhereElse";
import { Experiment, isVariantEnabled } from "components/utility/experiment";
import { UitkLayoutConditionalGridSpan } from "uitk-react-layout-grid";
import { Viewport, ViewSmall, ViewMedium } from "@shared-ui/viewport-context";

export const FlightHotelDefault = observer(
  ({
    context,
    packageWizardState,
    setInputsRefs,
    togglePartialStay,
    toggleStaySomewhereElse,
    globalConfig,
  }: PackageSubLOBProps) => {
    const halfWizard = globalConfig?.halfWizard;
    const locationColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 12, large: halfWizard ? 12 : 8 };
    const datesColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 12, large: halfWizard ? 12 : 4 };
    const staySomewhereElseToggleColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 12, large: 12 };
    const staySomewhereElseColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 6, large: 4 };
    const datesPartialStayColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 12, large: halfWizard ? 12 : 8 };

    const { isFlightHotelDefaultFormValid, updateInvalidFormsState, isDesktop } = packageWizardState;

    const isStaySomewhereElseEnabled =
      isVariantEnabled(context, Experiment.MIT_PWASF_PKGFLEXIBILITY_FSSSE) && isDesktop;

    if (isFlightHotelDefaultFormValid) {
      updateInvalidFormsState();
    }

    const renderPartialDates = ({ stackedDates = false }: { stackedDates?: boolean }) => (
      <Dates
        lobState={packageWizardState}
        isPartialStay
        colSpan={datesPartialStayColSpan}
        startId="d1-partial"
        endId="d2-partial"
        setInputsRefs={setInputsRefs}
        stackedDates={stackedDates}
      />
    );

    return (
      <>
        <Location
          originField
          destinationField
          lobState={packageWizardState}
          colSpan={locationColSpan}
          setInputsRefs={setInputsRefs}
          showSwapLocationsControl
          globalConfig={globalConfig}
        />
        <Dates lobState={packageWizardState} colSpan={datesColSpan} setInputsRefs={setInputsRefs} />

        {isStaySomewhereElseEnabled && (
          <>
            <StaySomewhereElseToggle
              colSpan={staySomewhereElseToggleColSpan}
              toggleStaySomewhereElse={toggleStaySomewhereElse}
              packageWizardState={packageWizardState}
            />
            {packageWizardState.staySomewhereElse && (
              <StaySomewhereElse lobState={packageWizardState} colSpan={staySomewhereElseColSpan} />
            )}
          </>
        )}

        <PackagePartialStay
          togglePartialStay={togglePartialStay}
          packageWizardState={packageWizardState}
          partialStayAccommodationLabel={locKeys.partialStayAccommodationLabel}
        />

        {packageWizardState.partialStay && (
          <Viewport>
            <ViewSmall>{renderPartialDates({ stackedDates: true })}</ViewSmall>
            <ViewMedium>{renderPartialDates({})}</ViewMedium>
          </Viewport>
        )}
      </>
    );
  }
);
